"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorPrefix = exports.default = void 0;
var errorPrefix = 'Heliotrope Error: ';
exports.errorPrefix = errorPrefix;

function heliotropeError(message) {
  return new Error("".concat(errorPrefix).concat(message));
}

var _default = heliotropeError;
exports.default = _default;
//# sourceMappingURL=heliotropeError.js.map